/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export type InventoryControllerGetAvailableFiltersV1Params = {
  /**
   * Optional filters to pre-filter available options
   */
  deviceTypeId?: string;
  /**
   * Optional filters to pre-filter available options
   */
  deviceMakerId?: string;
  /**
   * Optional filters to pre-filter available options
   */
  batchId?: string;
};
